import { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Crown } from "lucide-react";
import { useAuth } from "@/contexts/auth";
import { checkPremiumStatusSync } from "@/App";
import { Badge } from "@/components/ui/badge";
import { useLanguage } from "@/contexts/language";
import LanguageSwitcher from "./LanguageSwitcher";
import NavItems from "./navigation/NavItems";
import UserAuthButtons from "./navigation/UserAuthButtons";
import MobileMenu from "./navigation/MobileMenu";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user } = useAuth();
  const isPremium = checkPremiumStatusSync();
  const { language } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrolled]);

  return (
    <header 
      className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300 ease-in-out",
        scrolled ? "glass-card py-3" : "bg-transparent py-5"
      )}
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex items-center justify-between">
          <NavLink 
            to="/" 
            className="text-xl font-medium tracking-tight transition-opacity duration-200 hover:opacity-80 flex items-center"
          >
            LittleAI Diary
            {isPremium && (
              <Badge variant="outline" className="ml-2 bg-amber-500/10 text-amber-700 border-amber-200">
                <Crown className="h-3 w-3 mr-1" />
                Premium
              </Badge>
            )}
          </NavLink>
          
          <nav className="hidden md:flex items-center space-x-1 md:space-x-2">
            <NavItems />
            <LanguageSwitcher />
            <UserAuthButtons />
          </nav>
          
          <MobileMenu 
            mobileMenuOpen={mobileMenuOpen}
            setMobileMenuOpen={setMobileMenuOpen}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
